/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StepErrorDto } from './StepErrorDto';
import {
    StepErrorDtoFromJSON,
    StepErrorDtoFromJSONTyped,
    StepErrorDtoToJSON,
} from './StepErrorDto';

/**
 * 
 * @export
 * @interface GetStageDefinitionWithStatusDto
 */
export interface GetStageDefinitionWithStatusDto {
    /**
     * 
     * @type {string}
     * @memberof GetStageDefinitionWithStatusDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetStageDefinitionWithStatusDto
     */
    stageType: GetStageDefinitionWithStatusDtoStageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetStageDefinitionWithStatusDto
     */
    order: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetStageDefinitionWithStatusDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetStageDefinitionWithStatusDto
     */
    status: GetStageDefinitionWithStatusDtoStatusEnum;
    /**
     * 
     * @type {Array<StepErrorDto>}
     * @memberof GetStageDefinitionWithStatusDto
     */
    errors: Array<StepErrorDto>;
}


/**
 * @export
 */
export const GetStageDefinitionWithStatusDtoStageTypeEnum = {
    CampaignCompletion: 'CampaignCompletion',
    Contracts: 'Contracts',
    IntercompanyOrders: 'IntercompanyOrders',
    CampaignSettlement: 'CampaignSettlement'
} as const;
export type GetStageDefinitionWithStatusDtoStageTypeEnum = typeof GetStageDefinitionWithStatusDtoStageTypeEnum[keyof typeof GetStageDefinitionWithStatusDtoStageTypeEnum];

/**
 * @export
 */
export const GetStageDefinitionWithStatusDtoStatusEnum = {
    NotStarted: 'NotStarted',
    InProgress: 'InProgress',
    Error: 'Error',
    Completed: 'Completed',
    NotApplicable: 'NotApplicable'
} as const;
export type GetStageDefinitionWithStatusDtoStatusEnum = typeof GetStageDefinitionWithStatusDtoStatusEnum[keyof typeof GetStageDefinitionWithStatusDtoStatusEnum];


/**
 * Check if a given object implements the GetStageDefinitionWithStatusDto interface.
 */
export function instanceOfGetStageDefinitionWithStatusDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageType" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "errors" in value;

    return isInstance;
}

export function GetStageDefinitionWithStatusDtoFromJSON(json: any): GetStageDefinitionWithStatusDto {
    return GetStageDefinitionWithStatusDtoFromJSONTyped(json, false);
}

export function GetStageDefinitionWithStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStageDefinitionWithStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageType': json['stageType'],
        'order': json['order'],
        'active': json['active'],
        'status': json['status'],
        'errors': ((json['errors'] as Array<any>).map(StepErrorDtoFromJSON)),
    };
}

export function GetStageDefinitionWithStatusDtoToJSON(value?: GetStageDefinitionWithStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageType': value.stageType,
        'order': value.order,
        'active': value.active,
        'status': value.status,
        'errors': ((value.errors as Array<any>).map(StepErrorDtoToJSON)),
    };
}

